import searchResults from "./search_results"
import getMoreResults from "./get_more_results"
import viewToggle from "./view_toggle"

const reducers = {
  searchResults,
  getMoreResults,
  viewToggle,
}

export default reducers
